import { getUuid } from '@models/utils/uuid';
import { BaseModel, Guid, RecursivePartial, SM } from '@models/base';
import { TaskChecklist } from './task-checklist';

export class TaskTemplate extends BaseModel {
    orgId!: Guid;
    subj?: string;
    assignee?: Guid;
    assigneeGroup?: Guid;
    projectId?: Guid;
    typeId?: Guid;
    watchers?: string[];
    approvers?: string[];
    dueDateDays?: number;
    startDateDays?: number;
    plannedHours?: number;
    priority?: number;
    tagIds?: string[];
    checklist?: TaskChecklist;
    customValues?: SM<any>;

    id!: string;
    name?: string;
    created!: Date;
    lastUsed?: Date;
    usedCount: number = 0;

    constructor(json?: RecursivePartial<TaskTemplate>) {
        super(json);
        this.parseTaskTemplate(json || {});
    }

    parse(json: RecursivePartial<TaskTemplate>): TaskTemplate {
        super.parse(json);
        this.parseTaskTemplate(json);
        return this;
    }

    private parseTaskTemplate(json: RecursivePartial<TaskTemplate>): void {
        TaskTemplate.assignFields<TaskTemplate>(this, json, [
            'orgId',
            'subj',
            'assignee',
            'assigneeGroup',
            'projectId',
            'typeId',
            'watchers',
            'approvers',
            'dueDateDays',
            'startDateDays',
            'plannedHours',
            'priority',
            'tagIds',
            'customValues',
            'id',
            'name',
            'usedCount'
        ]);
        TaskTemplate.assignDates<TaskTemplate>(this, json, ['created', 'lastUsed']);
        TaskTemplate.assignClassFields<TaskTemplate>(this, json, { checklist: TaskChecklist });
        if (this.priority && (this.priority > 3 || this.priority < 0)) {
            this.priority = 0;
        }
        if (!this.id) {
            this.id = getUuid();
        }
        if (!this.created) {
            this.created = new Date();
        }
    }

}
